export default "__VITE_ASSET__CGxYPT4c__"